import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface Company {
  entityName: string
  taxId: string
  dba: string
  corporatePhone: string
  extension: string
  street1: string
  street2: string
  city: string
  state: string
  zip: string
  country: string
}

const initialState: Company = {
  entityName: '',
  taxId: '',
  dba: '',
  corporatePhone: '',
  extension: '',
  street1: '',
  street2: '',
  city: '',
  state: '',
  zip: '',
  country: '',
};

export const companySlice = createSlice({
  name: 'company',

  initialState,

  reducers: {
    setCompany(state, action: PayloadAction<Company>) {
      state.entityName = action.payload.entityName;
      state.taxId = action.payload.taxId;
      state.dba = action.payload.dba;
      state.corporatePhone = action.payload.corporatePhone;
      state.extension = action.payload.extension;
      state.street1 = action.payload.street1;
      state.street2 = action.payload.street2;
      state.city = action.payload.city;
      state.state = action.payload.state;
      state.zip = action.payload.zip;
      state.country = action.payload.country;
    },
  },
});

export const companyActions = companySlice.actions;
export type CompanySlice = {
  [companySlice.name]: ReturnType<typeof companySlice['reducer']>
};
